exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-nolabel[data-v-f03abf4a]  .el-form-item__content{margin-left:0!important;margin-top:20px!important}.custom-height[data-v-f03abf4a]{height:calc(100% - 95px)}.detail-height[data-v-f03abf4a]{height:calc(100% - 50px)}", ""]);

// exports
